// extracted by mini-css-extract-plugin
module.exports = {"base":"PopularPostCard--base--3nc_P","title":"PopularPostCard--title--xR7jv","imageWrapper":"PopularPostCard--imageWrapper--23Dvy"};